import isEmpty from "lodash/isEmpty";
import { logger } from "./loggerHelper";

export const getLocal = (NAME: string): unknown => {
  try {
    const data = localStorage.getItem(NAME);
    if (data) {
      const parsed = JSON.parse(data);
      if (!isEmpty(parsed)) {
        return parsed;
      }
    }
  } catch (error) {
    logger.error("Error getting from localStorage:", error);
  }
  return undefined;
};

export const setLocal = (NAME: string, DATA: unknown): void => {
  try {
    localStorage.setItem(NAME, JSON.stringify(DATA));
  } catch (error) {
    logger.error("Error setting localStorage:", error);
  }
};

export const removeLocal = (NAME: string): void => {
  try {
    localStorage.removeItem(NAME);
  } catch (error) {
    logger.error("Error removing from localStorage:", error);
  }
};

export const clearLocal = (): void => {
  try {
    localStorage.clear();
    sessionStorage.clear();
  } catch (error) {
    logger.error("Error clearing storage:", error);
  }
};

const isSafeRedirectPath = (path: unknown): path is string => {
  return (
    typeof path === "string" &&
    path.startsWith("/") &&
    !path.startsWith("//") &&
    !path.startsWith("/\\")
  );
};

export const getRedirectPath = (): string | null => {
  try {
    // Try sessionStorage first
    const sessionRedirect = sessionStorage.getItem("redirectAfterLogin");
    if (sessionRedirect) {
      // Clear from both storages when found in sessionStorage
      sessionStorage.removeItem("redirectAfterLogin");
      localStorage.removeItem("redirectAfterLogin");
      if (!isSafeRedirectPath(sessionRedirect)) return null;
      return sessionRedirect;
    }

    // Fall back to localStorage
    const localRedirect = localStorage.getItem("redirectAfterLogin");
    if (localRedirect) {
      // Clear from both storages when found in localStorage
      localStorage.removeItem("redirectAfterLogin");
      sessionStorage.removeItem("redirectAfterLogin");
      if (!isSafeRedirectPath(localRedirect)) return null;
      return localRedirect;
    }

    return null;
  } catch (error) {
    logger.error("Error accessing storage:", error);
    return null;
  }
};

export const setRedirectPath = (path: string): boolean => {
  try {
    if (!isSafeRedirectPath(path)) return false;

    // Store in both storage types for redundancy
    localStorage.setItem("redirectAfterLogin", path);
    sessionStorage.setItem("redirectAfterLogin", path);
    return true;
  } catch (error) {
    logger.error("Error setting redirect path:", error);
    return false;
  }
};

export const clearRedirectPath = (): void => {
  try {
    sessionStorage.removeItem("redirectAfterLogin");
    localStorage.removeItem("redirectAfterLogin");
  } catch (error) {
    logger.error("Error clearing redirect path:", error);
  }
};
